var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { roasterCountry as api, office as officeApi, warehouse as warehouseApi, } from '../../api';
import { useRequest } from '../../hooks/requestHook';
import useColumnEditField from '../../hooks/hoc/useColumnEditField';
import useRecordSelectField from '../../hooks/hoc/useRecordSelectField';
import { useRoasterCountries } from '../../hooks/useRoasterCountries';
import { useNotify } from '../../hooks/notificationHook';
import { camelize } from '../../utils/camelize';
import { column, currencyColumn, booleanColumn, numericColumn, } from '../../hooks/useColumns';
import { formatPercentage } from '../../utils/format';
import { EditableTaxTargetValues } from '../../constants/taxTargetValues';
import MaterialTable from '../MaterialTable';
import PageLayout from '../atoms/PageLayout';
var initialFormData = {
    code: '',
    currency: '',
    office: { id: '' },
    warehouseIds: [],
    taxRate: '',
    taxName: '',
    taxTarget: '',
    eoriNumberEnabled: false,
    vatReverseChargeEnabled: false,
};
var toRequestParams = function (country, rejectKeys) {
    if (rejectKeys === void 0) { rejectKeys = []; }
    var params = {
        code: country.code,
        office_id: country.office.id,
        currency: country.currency,
        warehouse_ids: country.warehouseIds,
        tax_rate: country.taxRate,
        tax_name: country.taxName,
        tax_target: country.taxTarget,
        eori_number_enabled: country.eoriNumberEnabled,
        vat_reverse_charge_enabled: country.vatReverseChargeEnabled,
    };
    rejectKeys.forEach(function (key) { return delete params[key]; });
    return params;
};
var AdminRoasterCountriesPage = function () {
    var t = useTranslation().t;
    var _a = useRoasterCountries(), loading = _a.loading, rawRoasterCountries = _a.roasterCountries, reload = _a.reload;
    var createApi = useRequest(api.create);
    var updateApi = useRequest(api.update);
    var destroyApi = useRequest(api.destroy);
    var notify = useNotify();
    var roasterCountries = rawRoasterCountries.map(function (country) { return (__assign(__assign({}, country), { warehouseIds: country.warehouses.map(function (w) { return w.id; }) })); });
    var countryOptions = React.useMemo(function () {
        var allCountries = t('countries', { returnObjects: true });
        var sortCountries = Object.entries(allCountries).sort(function (a, b) {
            return a[1].localeCompare(b[1]);
        });
        return Object.fromEntries(sortCountries);
    }, [t]);
    var renderOfficeName = React.useCallback(function (roasterCountry) {
        var name = roasterCountry.office.name;
        return "".concat(name);
    }, []);
    var OfficeSelectField = useRecordSelectField({
        getRecordsApi: officeApi.getAll,
        nameProperty: 'name',
    });
    var OfficeColumnSelectField = useColumnEditField(OfficeSelectField, { size: 'small' });
    var WarehouseSelectField = useRecordSelectField({
        getRecordsApi: warehouseApi.getAll,
        nameProperty: 'name',
    });
    var WarehouseColumnSelectField = useColumnEditField(WarehouseSelectField, {
        size: 'small',
        multiple: true,
        variant: 'standard',
    });
    var renderWarehouses = React.useCallback(function (roasterCountry) {
        var warehouses = roasterCountry.warehouses;
        return warehouses
            .sort()
            .map(function (w) { return w.name; })
            .join(', ');
    }, []);
    var taxTargetOptions = React.useMemo(function () {
        return Object.assign.apply(Object, __spreadArray([{}], EditableTaxTargetValues.map(function (value) {
            var _a;
            return (_a = {},
                _a[value] = t("params.roasterCountry.taxTargets.".concat(camelize(value))),
                _a);
        }), false));
    }, [t]);
    var columns = React.useMemo(function () { return [
        column('code', {
            lookup: countryOptions,
            editable: 'onAdd',
        }),
        {
            field: 'office.id',
            title: t('params.office.name'),
            render: renderOfficeName,
            editComponent: OfficeColumnSelectField,
        },
        currencyColumn('currency'),
        {
            field: 'warehouseIds',
            title: t('params.warehouse.name'),
            render: renderWarehouses,
            editComponent: WarehouseColumnSelectField,
        },
        numericColumn('taxRate', {
            render: function (data) { return formatPercentage(data.taxRate); },
        }),
        column('taxName'),
        column('taxTarget', {
            lookup: taxTargetOptions,
        }),
        booleanColumn('eoriNumberEnabled'),
        booleanColumn('vatReverseChargeEnabled'),
    ]; }, [
        countryOptions,
        renderOfficeName,
        t,
        taxTargetOptions,
        renderWarehouses,
        WarehouseColumnSelectField,
        OfficeColumnSelectField,
    ]);
    var handleCreate = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var params, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {
                        roaster_country: toRequestParams(data),
                    };
                    return [4 /*yield*/, createApi(params)];
                case 1:
                    response = _a.sent();
                    if (!response) {
                        throw Error('error response');
                        return [2 /*return*/];
                    }
                    notify('success', [t('messages.createSuccess')]);
                    reload();
                    return [2 /*return*/];
            }
        });
    }); }, [createApi, reload, notify, t]);
    var handleUpdate = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        id: data.id,
                        roaster_country: toRequestParams(data, ['code']),
                    };
                    return [4 /*yield*/, updateApi(request)];
                case 1:
                    response = _a.sent();
                    if (!response) {
                        throw Error('error response');
                        return [2 /*return*/];
                    }
                    notify('success', [t('messages.updateSuccess')]);
                    reload();
                    return [2 /*return*/];
            }
        });
    }); }, [updateApi, reload, notify, t]);
    var handleDelete = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, destroyApi(data.id)];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.deleteSuccess')]);
                    reload();
                    return [2 /*return*/];
            }
        });
    }); }, [destroyApi, reload, notify, t]);
    return (React.createElement(PageLayout, { title: t('pages.roasterCountries.title') },
        React.createElement(MaterialTable, { model: "roasterCountry", isLoading: loading, columns: columns, data: roasterCountries, initialFormData: initialFormData, editable: {
                onRowAdd: handleCreate,
                onRowUpdate: handleUpdate,
                onRowDelete: handleDelete,
            } })));
};
export default AdminRoasterCountriesPage;
